module.exports = __webpack_public_path__ + "img/nodata.e08a71ed.png";